import { createTRPCProxyClient, httpBatchLink } from "@trpc/client";
import superjson from "superjson";
import { accountSessionMarker, adoptedGuestJwt } from "@/utils/guestAccess";

const configured = process.env.VUE_APP_TRPC_URL;
const base =
  configured == null || configured === ""
    ? ""
    : String(configured).replace(/\/+$/, "").replace(/\/trpc$/, "");

function decodeJwtPayload(token) {
  const part = String(token || "").split(".")[1];
  if (!part) return null;
  const b64 = part.replace(/-/g, "+").replace(/_/g, "/");
  const padded = b64 + "=".repeat((4 - (b64.length % 4)) % 4);
  return JSON.parse(atob(padded));
}

function guestAuthorization() {
  if (typeof window === "undefined") return null;
  const adopted = adoptedGuestJwt();
  // Sid da conta ganha de um JWT guest esquecido. Link recém-adotado ganha do sid.
  if (!adopted && accountSessionMarker()) return null;
  const token = adopted || window.localStorage.getItem("analytics_jwt");
  if (!token) return null;
  try {
    const payload = decodeJwtPayload(token);
    if (!payload || payload.is_guest !== true) return null;
    if (typeof payload.exp === "number" && payload.exp * 1000 <= Date.now()) return null;
    return `Bearer ${token}`;
  } catch (error) {
    return null;
  }
}

/** Sid Redis do login. Cookie httpOnly não viaja analytics.* → app.00px.com.br. */
function opaqueSessionSid() {
  if (typeof window === "undefined") return null;
  const reports = window.localStorage.getItem("reportsSessionId");
  const sessionId = window.localStorage.getItem("sessionId");
  for (const candidate of [reports, sessionId]) {
    if (!candidate || candidate === "trpc" || candidate === "guest") continue;
    if (candidate.split(".").length === 3) continue;
    if (candidate.length < 16) continue;
    return candidate;
  }
  return null;
}

export const trpc = createTRPCProxyClient({
  links: [
    httpBatchLink({
      url: `${base}/trpc`,
      transformer: superjson,
      methodOverride: "POST",
      headers() {
        const guest = guestAuthorization();
        if (!guest) return {};
        return {
          authorization: guest,
          "x-analytics-jwt": guest,
        };
      },
      fetch(url, options) {
        const headers = new Headers(options && options.headers);
        const guest = guestAuthorization();
        const sid = guest ? null : opaqueSessionSid();
        if (guest && !headers.has("Authorization")) {
          headers.set("Authorization", guest);
        } else if (sid && !headers.has("Authorization")) {
          headers.set("Authorization", sid);
        }
        if (sid && !headers.has("x-access-session")) {
          headers.set("x-access-session", sid);
        }
        return fetch(url, {
          ...options,
          headers,
          credentials: "include",
        });
      },
    }),
  ],
});
